/**
 * Internal Dependencies.
 */
import {
	USER_ROLE_ADMIN,
	USER_ROLE_MENTOR,
	USER_ROLE_EMPLOYEE,
	USER_ROLE_FIRED,
	USER_ROLE_COORDINATOR
} from '~/lib/constants.js';


export const $can = (user, permission, entity) => {
	switch (permission) {
		case 'edit-task':
		case 'add-task':
		case 'touch-monitor':
		case 'sync-monitor':
		case 'delete-comment':
		case 'add-red-point':
		case 'edit-points':
		case 'edit-priority':
		case 'view-milestones':
		case 'edit-milestones':
		case 'add-comment-type':
		case 'see-pm-system':
		case 'see-client-stats':
		case 'change-client-note-visibility' :
		case 'add-user-cases':
			return user.type === USER_ROLE_ADMIN || user.type === USER_ROLE_COORDINATOR;

		case 'send-user-messages':
		case 'run-qa':
			return user.type === USER_ROLE_MENTOR || user.type === USER_ROLE_ADMIN || user.type === USER_ROLE_COORDINATOR;

		case 'request-screenshots':
			return user.type === USER_ROLE_MENTOR || user.type === USER_ROLE_ADMIN || user.type === USER_ROLE_EMPLOYEE || user.type === USER_ROLE_COORDINATOR;

		case 'run-mail-shots':
		case 'use-screenshots-service':
		case 'view-task': // Everybody can see everything ...
		case 'add-notes':
		case 'test-html':
		case 'add-client-note':
			return true;

		case 'edit-comment': {
			// admins can edit all comments; regular users can edit their comments
			if (user.type === USER_ROLE_ADMIN || user.type === USER_ROLE_COORDINATOR) {
				return true;
			}

			if (entity.author.id === user.id) {
				return true;
			}

			return false;
		}
	}
}